import { AxiosResponse, InternalAxiosRequestConfig } from './types'
import { ElMessage } from 'element-plus'
import qs from 'qs'
import { SUCCESS_CODE, TRANSFORM_REQUEST_DATA } from '@/constants'
import { useUserStoreWithOut } from '@/store/modules/user'
import { objToFormData } from '@/utils'

const defaultRequestInterceptors = (config: InternalAxiosRequestConfig) => {
  if (
    config.method === 'post' &&
    config.headers['Content-Type'] === 'application/x-www-form-urlencoded'
  ) {
    config.data = qs.stringify(config.data)
  } else if (
    TRANSFORM_REQUEST_DATA &&
    config.method === 'post' &&
    config.headers['Content-Type'] === 'multipart/form-data' &&
    !(config.data instanceof FormData)
  ) {
    config.data = objToFormData(config.data)
  }
  if (config.method === 'get' && config.params) {
    let url = config.url as string
    url += '?'
    const keys = Object.keys(config.params)
    for (const key of keys) {
      if (config.params[key] !== void 0 && config.params[key] !== null) {
        url += `${key}=${encodeURIComponent(config.params[key])}&`
      }
    }
    url = url.substring(0, url.length - 1)
    config.params = {}
    config.url = url
  }
  return config
}

const defaultResponseInterceptors = (response: AxiosResponse) => {
  if (response?.config?.responseType === 'blob') {
    // 如果是文件流，直接过
    return response
  }

  const data = response.data

  // 有 errno 字段的接口，用 errno 判断
  if (data && 'errno' in data) {
    if (data.errno === SUCCESS_CODE) {
      return response.data
    } else {
      ElMessage.error(data.errmsg)
      // 登录过期：清理本地登录态并跳回登录页（兼容 errno / code 两种返回字段）
      if (data.errno == 499 || data.code == 499) {
        const userStore = useUserStoreWithOut()
        userStore.logout()
      }
      return Promise.reject(response.data)
    }
  }

  // 没有 errno 字段的接口，默认返回数据（兼容旧接口）
  return response.data
}

export { defaultResponseInterceptors, defaultRequestInterceptors }
